// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1P9_A","modalFooterButton":"ModalNotes_modalFooterButton__GhXSl"};